<template>
  <van-popup
    v-model="show"
    position="bottom"
    :safe-area-inset-bottom="true"
    :close-on-click-overlay="false"
  >
    <div class="p16">
      <!-- 车牌类型选择 -->
      <div class="cu-plate-type">
        <div
          v-for="item in typeList"
          :key="item.label"
          class="radio-item"
          @click="typeChange(item.value)"
        >
        <van-icon v-if="type == item.value" name="checked" color="#0e4ab7"/>
        <van-icon v-else name="circle" color="#0e4ab7"/>
          <span class="labelText">{{ item.label }}</span>
        </div>
      </div>
      <!-- 车牌输入框 -->
      <div class="cu-plate-body">
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 0 }"
          @click="inputSwitch"
          data-index="0"
        >
          <span>{{ currentInputValue[0] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 1 }"
          @click="inputSwitch"
          data-index="1"
        >
          <span>{{ currentInputValue[1] }}</span>
        </div>
        <div class="cu-plate-dot" />
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 2 }"
          @click="inputSwitch"
          data-index="2"
        >
          <span>{{ currentInputValue[2] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 3 }"
          @click="inputSwitch"
          data-index="3"
        >
          <span>{{ currentInputValue[3] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 4 }"
          @click="inputSwitch"
          data-index="4"
        >
          <span>{{ currentInputValue[4] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 5 }"
          @click="inputSwitch"
          data-index="5"
        >
          <span>{{ currentInputValue[5] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 6 }"
          @click="inputSwitch"
          data-index="6"
        >
          <span>{{ currentInputValue[6] }}</span>
        </div>
        <div
          class="cu-plate-word"
          :class="{ active: currentInputIndex == 7 }"
          @click="inputSwitch"
          v-if="type == '2'"
          data-index="7"
        >
          <span>{{ currentInputValue[7] }}</span>
        </div>
      </div>
      <!-- 车牌键盘 -->
      <div class="cu-plate-foot">
        <div style="height: 294px">
          <div class="cu-plate-keyboard">
            <template v-if="inputType == 1">
              <div
                class="cu-plate-key"
                v-for="el of provinceText"
                :key="el"
                :data-value="el"
                @click="chooseKey"
              >
                <div class="cu-plate-key-text">
                  {{ el }}
                </div>
              </div>
            </template>
            <template v-if="inputType >= 3">
              <div
                class="cu-plate-key"
                v-for="el of numberText"
                :key="el"
                :data-value="el"
                @click="chooseKey"
              >
                <div class="cu-plate-key-text">
                  {{ el }}
                </div>
              </div>
            </template>
            <template v-if="inputType >= 2">
              <div
                class="cu-plate-key"
                v-for="el of wordText"
                :key="el"
                :data-value="el"
                @click="chooseKey"
              >
                <div class="cu-plate-key-text">
                  {{ el }}
                </div>
              </div>
            </template>
            <template v-if="inputType == 4">
              <div
                class="cu-plate-key"
                v-for="el of lastWordText"
                :key="el"
                :data-value="el"
                @click="chooseKey"
              >
                <div class="cu-plate-key-text">
                  {{ el }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="cu-plate-btn-group">
          <div>
            <div
              class="cu-plate-btn cu-plate-btn--cancel"
              @click="handleClose"
            >
              取消
            </div>
          </div>
          <div>
            <div
              class="cu-plate-btn cu-plate-btn--delete"
              @click="handleDelete"
            >
              删除
            </div>
            <div
              class="cu-plate-btn cu-plate-btn--submit"
              @click="handleSubmit"
            >
              完成
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
  import Vue from 'vue';
  import { Popup } from 'vant';
  import 'vant/lib/popup/style';
  Vue.use(Popup);
  export default {
    data() {
      return {
        typeList: [
          { label: '普通车牌', value: '1' },
          { label: '新能源车牌', value: '2' },
          { label: '新车无牌', value: '3' },
        ],
        show: false, //是否显示键盘
        type: '1', //车牌类型
        currentInputIndex: 0, //当前编辑的输入框
        currentInputValue: ['', '', '', '', '', '', ''], //当前输入的车牌值
        provinceText: [
          '粤',
          '京',
          '冀',
          '沪',
          '津',
          '晋',
          '蒙',
          '辽',
          '吉',
          '黑',
          '苏',
          '浙',
          '皖',
          '闽',
          '赣',
          '鲁',
          '豫',
          '鄂',
          '湘',
          '桂',
          '琼',
          '渝',
          '川',
          '贵',
          '云',
          '藏',
          '陕',
          '甘',
          '青',
          '宁',
          '新',
        ],
        numberText: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
        wordText: [
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H',
          'J',
          'K',
          'L',
          'M',
          'N',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z',
        ],
        lastWordText: ['港', '澳', '学', '领', '警'],
      };
    },
    computed: {
      //输入框类型
      inputType() {
        switch (this.currentInputIndex) {
          case 0:
            return 1;
          case 1:
            return 2;
          case 2:
            return 3;
          case 3:
            return 3;
          case 4:
            return 3;
          case 5:
            return 3;
          case 6:
            return this.type == '2' ? 3 : 4;
          case 7:
            return 4;
          default:
            return 1;
        }
      },
    },
    methods: {
      //打开键盘时的初始化
      init(val) {
        this.show = true;
        const plateKey = (val||'').split('');
        if (plateKey.length === 7) {
          this.type = '1';
        } else if (plateKey.length === 8) {
          this.type = '2';
        }
        if (plateKey.length === 7 || plateKey.length === 8) {
          this.currentInputValue = plateKey;
          this.currentInputIndex = plateKey.length - 1;
        }
      },
      //关闭键盘，清空数据
      handleClose() {
        Object.assign(this.$data, this.$options.data());
      },
      //车牌类型切换
      typeChange(val) {
        this.type = val;
        this.currentInputIndex = 0;
        if(val == '3'){
            // 触发update事件，将车牌号码传递给父组件
            this.$emit('update', '新车无牌');
            // 关闭键盘
            this.handleClose();
        }else if (val == '1') {
          this.currentInputValue = ['', '', '', '', '', '', ''];
        } else {
          this.currentInputValue = ['', '', '', '', '', '', '', ''];
        }
      },
      // 点击切换输入框
      inputSwitch(e) {
        // 获取当前点击的元素的自定义属性index的值
        const { index } = e.currentTarget.dataset;
        // 将当前输入框的索引设置为点击的元素的索引
        this.currentInputIndex = parseInt(index);
      },
      // 点击键盘对应按键
      chooseKey(e) {
        // 获取当前元素的数据值
        const { value } = e.currentTarget.dataset;
        // 将当前元素的数据值设置到当前输入值的指定索引位置
        this.$set(this.currentInputValue, this.currentInputIndex, value);
        // 如果类型为1且当前输入索引小于6，则将当前输入索引加1
        if (this.type == '1' && this.currentInputIndex < 6) {
          this.currentInputIndex++;
        }
        // 如果类型为2且当前输入索引小于7，则将当前输入索引加1
        if (this.type == '2' && this.currentInputIndex < 7) {
          this.currentInputIndex++;
        }
      },
      // 删除操作
      handleDelete() {
        // 将当前输入框的值设置为空字符串
        this.$set(this.currentInputValue, this.currentInputIndex, '');
        // 如果当前输入框的索引不为0，则将当前输入框的索引减1
        if (this.currentInputIndex != 0) this.currentInputIndex--;
      },
      // 完成操作
      handleSubmit() {
        // 获取当前输入的车牌号码
        const plate = this.currentInputValue.join('');
        // 判断车牌号码长度是否正确
        let err = false;
        if (this.type == '1' && plate.length != 7) {
          err = true;
        } else if (this.type == '2' && plate.length != 8) {
          err = true;
        }
        if (err) {
          this.$toast('请输入完整的车牌号码');
          return;
        }
        // 触发update事件，将车牌号码传递给父组件
        this.$emit('update', plate);
        // 关闭键盘
        this.handleClose();
      },
    },
  };
</script>
<style lang="scss" scoped>
.p16{
    padding: 16px;
    .labelText{
        margin-left: 4px;
    }
}
.cu-plate-type {
    display: flex;
    flex: 1;
 
    .radio-item {
        display: flex;
 
        &:not(:first-child) {
            margin-left: 16px;
        }
    }
}
 
.cu-plate-body {
    box-sizing: border-box;
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
 
    .cu-plate-word {
        border: 1px solid #ccc;
        border-radius: 10px;
        height: 0;
        margin: 0 5px;
        box-sizing: border-box;
        padding-bottom: calc((100% - 70px) / 7);
        width: calc((100% - 70px) / 7);
        position: relative;
 
        &.active {
            border-color: #007aff;
            box-shadow: 0 0 15px 0 #007aff;
        }
 
        span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            font-weight: 500;
            font-size: 18px;
        }
    }
    .cu-plate-dot {
        width: 12px;
        height: 12px;
        background: #ccc;
        border-radius: 50%;
        margin: 0 5px;
        flex-shrink: 0;
    }
}
 
.cu-plate-keyboard {
    box-sizing: border-box;
    transition: all 0.3s;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px;
 
    .cu-plate-key {
        padding: 5px;
        box-sizing: border-box;
        width: 12.5%;
        line-height: 46px;
 
        .cu-plate-key-text {
            background: #fff;
            border-radius: 10px;
            box-shadow: 0 0 8px 0 #bbb;
            display: flex;
            align-items: center;
            justify-content: center;
 
            &:active {
                background: #efefef;
            }
        }
    }
}
 
.cu-plate-btn-group {
    display: flex;
    justify-content: space-between;
 
    .cu-plate-btn {
        display: inline-block;
        background: #fff;
        font-size: 16px;
        text-align: center;
        padding: 0 24px;
        border-radius: 8px;
        line-height: 34px;
        color: #666;
    }
 
    .cu-plate-btn--cancel {
        border: 1px solid #0e4ab7;
        color: #0e4ab7;
    }
 
    .cu-plate-btn--delete {
        color: #ed0a20;
        border: 1px solid #ed0a20;
    }
 
    .cu-plate-btn--submit {
        border: 1px solid #0e4ab7;
        margin-left: 16px;
        background: #0e4ab7;
        color: #fff;
    }
}
</style>